import { useLanguage } from "@/context/LanguageContext";
import { Link } from "react-router-dom";

const DonationCancel = () => {
  const { copy } = useLanguage();

  return (
    <div className="donation-page" data-testid="donation-cancel-page">
      <div className="donation-card" data-testid="donation-cancel-card">
        <h1 className="section-title" data-testid="donation-cancel-title">
          {copy.donationFlow.cancelTitle}
        </h1>
        <p className="section-text" data-testid="donation-cancel-body">
          {copy.donationFlow.cancelBody}
        </p>
        <div className="donation-actions" data-testid="donation-cancel-actions">
          <Link to="/" className="secondary-button" data-testid="donation-cancel-home">
            {copy.donationFlow.backHome}
          </Link>
          <Link to="/donate/checkout?amount=20" className="primary-button" data-testid="donation-cancel-retry">
            {copy.donationFlow.retry}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DonationCancel;
